import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=58e11667&"
import script from "./BottomBar.vue?vue&type=script&lang=js&"
export * from "./BottomBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAppBar,VBtn})
